import React, {Component} from 'react'
import {Container, Row, Col} from 'react-grid-system'

// STYLES
import styled from 'styled-components'

// HELPERS
import {Section} from '../../shared/helpers'

// COMPONENTS
import Title from '../../components/title/title.component'
import SubTitle from '../../components/subtitle/subtitle.component'

// ICONS
import Image1 from '../../assets/images/thumbnail-moradias.png'
import Image2 from '../../assets/images/thumbnail-hostels.png'
import Image3 from '../../assets/images/thumbnail-hospedagem.png'
import Image4 from '../../assets/images/thumbnail-apartamentos.png'
import Image5 from '../../assets/images/thumbnail-quartos.png'

export default class Recipients extends Component {
  render () {
    const {t, id} = this.props
    return (

      <Section id={id}>
        <Container>
          <Title color={'#2E84C6'} text={t('Destinatários')} />
          <SubTitle color={'#5C5A5A'} text={t('D_frase1')} />
          <Row style={{justifyContent: 'center'}}>
            <Col md={2} sm={12}>
              <RecipientsContent>
                <RecipientsImage>
                  <Image src={Image1} alt={t('Moradia')} />
                </RecipientsImage>
                <RecipientsText>
                  <p>{t('Moradia')}</p>
                </RecipientsText>
              </RecipientsContent>
            </Col>
            <Col md={2} sm={12}>
              <RecipientsContent>
                <RecipientsImage>
                  <Image src={Image3} alt={t('Estabelecimentos de Hospedagem')} />
                </RecipientsImage>
                <RecipientsText>
                  <p>{t('Estabelecimentos de Hospedagem')}</p>
                </RecipientsText>
              </RecipientsContent>
            </Col>
            <Col md={2} sm={12}>
              <RecipientsContent>
                <RecipientsImage>
                  <Image src={Image2} alt={t('Hostels')} />
                </RecipientsImage>
                <RecipientsText>
                  <p>{t('Hostels')}</p>
                </RecipientsText>
              </RecipientsContent>
            </Col>
            <Col md={2} sm={12}>
              <RecipientsContent>
                <RecipientsImage>
                  <Image src={Image4} alt={t('Apartamento')} />
                </RecipientsImage>
                <RecipientsText>
                  <p>{t('Apartamento')}</p>
                </RecipientsText>
              </RecipientsContent>
            </Col>
            <Col md={2} sm={12}>
              <RecipientsContent>
                <RecipientsImage>
                  <Image src={Image5} style={{borderRadius: '50%'}} alt={t('Quartos')} />
                </RecipientsImage>
                <RecipientsText>
                  <p>{t('Quartos')}</p>
                </RecipientsText>
              </RecipientsContent>
            </Col>
          </Row>
        </Container>
      </Section>

    )
  }
}

const RecipientsContent = styled.div`
    margin-top: 50px;
    padding: 5px;
    @media screen and (max-width: 768px) {
        margin-top: 40px;
        
    }
`
const RecipientsImage = styled.div`
    margin-bottom: 15px;
    text-align: center;

    @media screen and (min-width: 768px) and (max-width: 1200px) {
        img{
            width: 105px;
            height: 105px;
        }
    }
`
const RecipientsText = styled.div`
    color: #5C5A5A;
    font-family: Dosis;
    font-size: 24px;
    font-weight: 300;
    line-height: 31px;
    text-align: center;
    
    p{
        margin: 0;
    }

    @media screen and (min-width: 768px) and (max-width: 1200px) {
      font-size: 16px;
    }
`

const Image = styled.img`
 width: 150px
`



// WEBPACK FOOTER //
// ./src/sections/recipients/recipients.section.js